export default __webpack_public_path__ + "static/media/addTableIcon.c707c041.svg";